export const CATEGORIES = {
  feature: 'Feature',
  improvement: 'Improvement',
  bugfix: 'Bugfix',
  notification: 'Notification'
}
